import { render, staticRenderFns } from "./404NotFound.vue?vue&type=template&id=700bd3a6&"
import script from "./404NotFound.vue?vue&type=script&lang=js&"
export * from "./404NotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports